<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-15 11:24:40
-->
<template>
  <div class="ribbon--block-group">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>